import React, { useContext } from 'react';
import { UserType } from '@amzn/awscat-pattern-library-service-model';

import HeaderDashboardDropdown from './HeaderDashboardDropdown';
import HeaderManageDropdown from './HeaderManageDropdown';
import HeaderDefaultActionMenus from './HeaderDefaultActionMenus';
import { HeaderCollectionDropdown } from '../collection';
import HeaderCreateDropdown from './HeaderCreateDropdown';
import HeaderGuidanceDropdown from './HeaderGuidanceDropdown';
import { AppContext } from '../../contexts/AppContext';

const HeaderActionMenu = () => {
  const appContext = useContext(AppContext);
  const userProfile = appContext?.authnInfo?.userProfile;

  const renderCollectionDropdown = () => {
    if (userProfile?.type !== UserType.AWS) {
      return null;
    }
    return <HeaderCollectionDropdown />;
  };

  return (
    <>
      <HeaderDashboardDropdown />
      <HeaderManageDropdown />
      <HeaderGuidanceDropdown />
      {renderCollectionDropdown()}
      <HeaderCreateDropdown />
      <HeaderDefaultActionMenus />
    </>
  );
};

export default HeaderActionMenu;
